export default {
  watchListType: {
    COMPANY_GROUP: 'CompanyGroup',
    CUSTOM: 'Custom',
    SECTOR: 'Sector',
    CUSTOM_CW: 'CustomCW',
  },

  comGroupCode: {
    HNXIndex: 'HNX',
    UpcomIndex: 'UPCOM',
    VNINDEX: 'HOSE',
  },

  companyGroupShowTooltip: {
    HOSE: true,
    HNX: true,
    UPCOM: true,
  },
};
